"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MouseEnterDatumMutation = void 0;
const ChartStyles_1 = require("./ChartStyles");
exports.MouseEnterDatumMutation = [
    {
        target: 'data',
        mutation: props => ({
            style: Object.assign(Object.assign({}, props.style), ChartStyles_1.ChartStyles.dataHover),
        }),
    },
];
exports.default = exports.MouseEnterDatumMutation;
